export const HYPERLOCAL_DATA_SEGMENT_ACL_OBJECTS = [
    'HyperlocalDataSegmentDetail',
    'HyperlocalDataSegmentCreate',
    'HyperlocalDataSegmentList',
];
